import { AxiosResponse } from 'axios';
import { IncomingHttpHeaders } from 'http';
import { AbTestHashResponse } from '@doda/api-client/aspida/@types';
import { appAxios } from '../libs/axios/appAxios';

export const getAbtestGroupNo = async (
  projectId: string,
  headers?: IncomingHttpHeaders,
  assignmentId?: string
) => {
  return appAxios({
    url: `/api/v1/abtests/${projectId}`,
    headers,
    params: { assignmentId },
  })
    .then((res: AxiosResponse<AbTestHashResponse>) => {
      return res.data.groupNo;
    })
    .catch(() => {
      return undefined;
    });
};
